module.exports = __webpack_public_path__ + "img/peizhi-3.46705656.png";